export default "__VITE_ASSET__ljKcUQ8O__"